import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { ErrorBoundaryFlag as ErrorBoundary } from '@atlassian/jira-error-boundary-flag-renderer';
import { GenericPermissionErrorPageAsync } from '@atlassian/jira-error-pages/src/async.tsx';
import { DocumentTitle } from '@atlassian/jira-global-document-title';
import { useIntl } from '@atlassian/jira-intl';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import ServiceDeskAutomationSummary from '@atlassian/jira-servicedesk-automation-summary-v2/src/view/index.tsx';
import { useProjectContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/project-context/index.tsx';
import { ProjectSubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/project-sub-product-updater';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import messages from './messages';

const METRICS_PAGE_ID = 'project-settings-apps.service-desk-automation-summary';

export const View = () => {
	const { locale, baseUrl } = useTenantContext();
	const data = useProjectContext();

	const { formatMessage } = useIntl();

	if (data === null || data.project === null) {
		return <GenericPermissionErrorPageAsync />;
	}
	const { key: projectKey, id: projectId, isSimplified } = data.project;

	const initialState = {
		appProps: {
			baseUrl,
			locale,
			projectKey,
			projectId,
			isProjectSimplified: isSimplified,
		},
	};

	return (
		<ProjectSettingsController projectKey={projectKey}>
			<ErrorBoundary id={METRICS_PAGE_ID}>
				<ProjectSubProductUpdater />
				<DocumentTitle title={formatMessage(messages.documentTitle)} />
				<ThemeProvider theme={{}}>
					<ServiceDeskAnalyticsContext>
						<AppContainer baseUrl={baseUrl} projectKey={projectKey}>
							<ServiceDeskAutomationSummary baseUrl={baseUrl} initialState={initialState} />
						</AppContainer>
					</ServiceDeskAnalyticsContext>
				</ThemeProvider>
			</ErrorBoundary>
		</ProjectSettingsController>
	);
};

export default View;
